import { cloneDeep } from 'lodash';


const INIT = 'auth/INIT';
export const REFRESH_REQUEST = 'auth/REFRESH_REQUEST';
export const REFRESH_SUCCESS = 'auth/REFRESH_SUCCESS';
export const REFRESH_FAILURE = 'auth/REFRESH_FAILURE';
export const LOGOUT_USER = 'auth/LOGOUT_USER';


export const defaultState = {
  isFetching: false,
  errorMessage: '',
  token: '',
  user: {},
};

export function getLoggedInAuthState(user, token) {
  return {
    isFetching: false,
    errorMessage: '',
    token,
    user,
  };
}


export const ACTIONS = {
  init: () => ({ type: INIT }),
};

function auth(state = defaultState, action) {
  switch (action.type) {
    case INIT:
      return Object.assign({}, state);
    case REFRESH_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        errorMessage: '',
      });
    case REFRESH_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: '',
        token: action.token,
        refreshToken: action.refToken,
        user: Object.assign({}, state.user, action.user),
      });
    case LOGOUT_USER:
      return Object.assign({}, state, {
        token: null,
        refreshToken: null,
        user: Object.assign({}, state.user, {}),
      });
    case REFRESH_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.message,
        clientToken: '',
      });
    default:
      return Object.assign({}, state);
  }
}

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/routeReducers/auth.js